import { useState } from 'react';
import { observer } from 'mobx-react-lite';
import { IPrNewsSFilter } from 'src/@types/SearchFilterTypes';
import { Page } from 'src/components/Page';

import NewsGrid from './NewsGrid';
import SearchForm from './SearchForm';
/** * ## News 설명 * */
export const News = observer(() => {
  // 검색 조건
  const [searchData, setSearchData] = useState<Partial<IPrNewsSFilter>>({});
  // 목록 검색
  const onSearch = (data: IPrNewsSFilter) => {
    setSearchData(data);
  };
  return (
    <Page>
      <SearchForm onSearch={onSearch} />
      <NewsGrid searchData={searchData} />
    </Page>
  );
});
export default News;
